import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useProducts } from '../../../queryHooks/useProducts';

type FormProductSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormProductSelect = (props: FormProductSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('warehouse.outboundDeliveries.filters');
  const { data, isLoading } = useProducts();

  const options = data?.map(({ id, name }) => {
    return { id, label: name };
  });

  return (
    <FormSelectId
      {...props}
      label={tWrapper('product')}
      loading={isLoading}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
